import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ListView from "../../../utils/Custom/listView";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { useNavigate } from "react-router-dom";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { submitSiteDelete } from "../../../utils/commonComponent/delete";
import { AddButton } from "../../../utils/Custom/Button";
import { clienTypes } from "../../../utils/commonComponent/common";

const headers = ["id","serviceRequestNo","requisitionDate","Client","inspectionDate"];

const fields = [
  { value: "serviceRequestNo", label: "Service Request No" },
  { value: "client", label: "Client" },
];

const InspectionServiceList = () => {
  const navigate = useNavigate();
  const handleEdit = (row) => navigate(`/inspectionService/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("serviceRequest", row.id);

  const [inspectionServiceList, setInspectionServiceList] = useState([]);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [searched, setSearched] = React.useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleSelect = (row) => {
    console.log("Selected ID:", row.id);
  };

  const getQuery = () => {
    let whereConditions = "";
    const colMap = {
      client: "cl.companyName",
      serviceRequestNo: "sr.serviceRequestNo",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions = ` AND LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`;
    }

    let query = `SELECT sr.*, cl.type as clientType, cl.companyName as Client FROM serviceRequest sr left JOIN clients cl ON sr.clientId = cl.id  WHERE sr.status = 1 ${whereConditions} ORDER BY sr.id DESC`;

    // let query = `SELECT * from serviceRequest WHERE status = 1 ${whereConditions} ORDER BY id DESC`;

    return query;
  };

  const fetchserviceRequest = async () => {
    try {
      const query = getQuery();
      const serviceRequest = await fetchQuery(query);
      const modified = serviceRequest?.map((item) => {
        return {
          ...item,
          Client: item.Client + (item.clientType ? ` (${clienTypes.find((ct) => ct.value == item.clientType)?.short || ""})` : ""),          
        };
      });
      setInspectionServiceList(modified);
    } catch (error) {
      console.error("Error fetching serviceRequest data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchserviceRequest();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("");
    setSearchKey("");
  };

  useEffect(() => {
    fetchserviceRequest();
  }, []);

  useEffect(() => {
    if (searched == false) {
      fetchserviceRequest();
    }
  }, [searched]);

  return (
    <>
      <AddButton
        id="btn-add-outline"
        to="/inspectionService/0"
        label="Add Inspection Service"
        icon={<AddIcon fontSize="small" />}
      />
      <ListSearchSection
        title="Search Inspection Service"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <ListView
        headers={headers}
        data={inspectionServiceList}
        actions={{
          edit: handleEdit,
          delete: handleDelete,
           view: (row) => navigate(`/inspectionService/print/${row.id}`),
        }}
        showCheckbox={true} //enable checkbox
        deleteTableName={"serviceRequest"}
      />
    </>
  );
};

export default InspectionServiceList;
